import * as React from 'react';
import { Link } from 'gatsby';
import { Highlight } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

import { resizeShopifyImage } from '../../utilities';

function SearchHit({ hit }) {
  return (
    <article>
      <Link
        to={`/${hit.tags.includes('Mens') ? 'mens' : 'ladies'}/products/${
          hit.handle
        }`}
        className="flex items-center px-8 py-2 -mx-4 focus:outline-none focus:bg-gray-200 hover:bg-gray-100"
      >
        <img
          src={
            hit.image
              ? resizeShopifyImage({
                  url: hit.image,
                  width: 44,
                })
              : ''
          }
          alt=""
          width={44}
          height={44}
          className="object-contain bg-white h-11 w-11"
        />
        <span className="ml-2">
          <Highlight attribute="title" hit={hit} tagName="mark" />
        </span>
      </Link>
    </article>
  );
}

SearchHit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export { SearchHit };
